<!-- Main container -->
<div class="layout-col full">
  <elder-table
    class="flex outlined"
    matSort
    [data]="pTimeSpecs$ | async"
    [selectionMultiEnabled]="true"
    [selectionVisible]="true"
    (itemClick)="onClick($event)"
  >
    <elder-data-toolbar
      *elderTableToolbar
      [canMore]="false"
      [canAdd]="true"
      [canRemove]="true"
      (requestNew)="onNew($event)"
      (requestRemove)="onRemove($event)"
    >
    </elder-data-toolbar>

    <!-- icon -->
    <ng-container matColumnDef="icon">
      <th mat-header-cell *matHeaderCellDef style="width: 5%"></th>
      <td mat-cell *matCellDef="let spec">
        <div class="place-start-center">
          <mat-icon [matTooltip]="'ID: ' + spec.id">label</mat-icon>
        </div>
      </td>
    </ng-container>

    <!-- number Column -->
    <ng-container matColumnDef="number">
      <th mat-header-cell *matHeaderCellDef style="width: 5%">{{ 'context.group' | translate }}</th>
      <td mat-cell *matCellDef="let spec">
        {{ spec.setNumber }}
      </td>
    </ng-container>

    <!-- property Column -->
    <ng-container matColumnDef="property">
      <th mat-header-cell *matHeaderCellDef style="width: 30%">
        {{ 'products.properties.property' | translate }}
      </th>
      <td mat-cell *matCellDef="let spec">
        <div class="layout-col">
          <span>{{ spec.property.description }}</span>
          <span class="text-body-small">{{ spec.property.id }}</span>
        </div>
      </td>
    </ng-container>

    <!-- description Column -->
    <ng-container matColumnDef="description">
      <th mat-header-cell *matHeaderCellDef>{{ 'context.description' | translate }}</th>
      <td mat-cell *matCellDef="let spec">{{ spec.description }}</td>
    </ng-container>

    <!-- order controls -->
    <ng-container matColumnDef="actions">
      <th mat-header-cell *matHeaderCellDef></th>
      <td mat-cell *matCellDef="let spec">
        <div class="place-start-center">
          <button mat-icon-button (click)="moveUp(spec)" elderStopEventPropagation>
            <mat-icon>arrow_drop_up</mat-icon>
          </button>
          <button mat-icon-button (click)="moveDown(spec)" elderStopEventPropagation>
            <mat-icon>arrow_drop_down</mat-icon>
          </button>
        </div>
      </td>
    </ng-container>

    <!-- required Column
    <ng-container matColumnDef="required">
        <th mat-header-cell *matHeaderCellDef style="width: 10%">{{'context.input-required' | translate}}</th>
        <td mat-cell *matCellDef="let constraintSpec"> {{constraintSpec.required}} </td>
    </ng-container>
    -->
  </elder-table>
</div>
